import { mapCompPlan } from 'app/pages/tpoPortal/commandCenterHome/CommandCenterHome/compPlan.utils';
import { brokerCompPlanApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

// Broker-facing read — a 403 (DEV-3647 broker-auth gap) must degrade to the empty
// state, never trigger the global forbidden page-reload loop. The forbidden-skip stops
// the reload; fetchSafe swallows the rejection so it leaves no unhandled-rejection
// console error / dev overlay (DEV-4370).
const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_COMP_PLAN_ACTION_TYPE = createNamedActions('commandCenterCompPlan', {
  SET_COMP_PLAN: 'SET_COMP_PLAN',
});

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterCompPlanAction = catchAsyncActionError(() => async dispatch => {
  const data = await fetchSafe(() =>
    brokerCompPlanApi.getCompPlan({ config: SKIP_FORBIDDEN_CONFIG }),
  );

  return dispatch({
    type: COMMAND_CENTER_COMP_PLAN_ACTION_TYPE.SET_COMP_PLAN,
    payload: mapCompPlan(data),
  });
});
